export default __webpack_public_path__ + "static/media/our-partners.10fe1553.png";